export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'default',
  GHOST: 'ghost',
  TEXT: 'text',
} as const;
